import { createStyleSheet } from 'react-native-unistyles';
import FontWeight from './fontWeights';
import { WindowInformation } from '../services/window-information';

const inputStylesheet = createStyleSheet(theme => ({
    container: {
        gap: 4,
    },
    labelContainer: {
        flexDirection: 'row',
        gap: 4,
    },
    label: {
        color: theme.colors.neutral[500],
        fontSize: 14,
        height: 19,
        fontWeight: FontWeight.semiBold,
    },
    textRequired: {
        color: theme.colors.errors['300'],
        fontWeight: FontWeight.bold,
        fontSize: 14,
        height: 19,
    },
    input: ({ invalid, disabled, placeholder, hasPrefix, multiline, hasSuffix }: {
        invalid?: boolean;
        disabled?: boolean;
        placeholder?: boolean;
        hasPrefix?: boolean;
        multiline?: boolean;
        hasSuffix?: boolean;
    }) => {
        const windowInfo = WindowInformation();

        return {
            fontSize: windowInfo.isMobile ? 16 : 14,
            fontFamily: 'Open Sans',
            fontWeight: placeholder ? FontWeight.regular : FontWeight.medium,
            backgroundColor: disabled ? theme.colors.backgrounds['BG-1'] : theme.colors.white[500],
            borderColor: invalid ? theme.colors.errors[300] : theme.colors.neutral[200],
            color: placeholder ? theme.colors.neutral[300] : theme.colors.neutral[400],
            borderWidth: 1,
            padding: 12,
            borderTopLeftRadius: hasPrefix ? 0 : 6,
            borderBottomLeftRadius: hasPrefix ? 0 : 6,
            borderTopRightRadius: hasSuffix ? 0 : 6,
            borderBottomRightRadius: hasSuffix ? 0 : 6,
            height: multiline ? undefined : (windowInfo.isMobile ? 56 : 40),
        };
    },
    inputPrefix: ({ invalid }: { invalid?: boolean; }) => {
        const windowInfo = WindowInformation();

        return {
            justifyContent: 'center',
            paddingHorizontal: 12,
            height: windowInfo.isMobile ? 56 : 40,
            backgroundColor: theme.colors.backgrounds['BG-1'],
            borderColor: invalid ? theme.colors.errors[300] : theme.colors.neutral[200],
            borderWidth: 1,
            borderRightWidth: 0,
            borderTopLeftRadius: 6,
            borderBottomLeftRadius: 6,
            flexShrink: 0,
        };
    },
    inputSuffix: ({ invalid }: { invalid?: boolean; }) => {
        const windowInfo = WindowInformation();

        return {
            justifyContent: 'center',
            paddingHorizontal: 12,
            height: windowInfo.isMobile ? 56 : 40,
            backgroundColor: theme.colors.backgrounds['BG-1'],
            borderColor: invalid ? theme.colors.errors[300] : theme.colors.neutral[200],
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopRightRadius: 6,
            borderBottomRightRadius: 6,
            flexShrink: 0,
        };
    },
    inputPrefixText: {
        fontSize: 14,
        color: theme.colors.neutral['400'],
    },
    errorMessage: {
        color: theme.colors.errors['300'],
        fontSize: 12,
    },
    maxCharactersMessage: {
        alignSelf: 'flex-end',
        fontSize: 12,
        fontWeight: FontWeight.semiBold,
        color: theme.colors.neutral['400']
    },
}));

export default inputStylesheet;
